<div class="discharge-report-header">
  @if (issuedReport.exists) {
    <div class="discharge-report-issued-banner">
      <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
      <span>
        <strong>{{ 'A discharge report has already been issued' | translate }}</strong>
        {{ 'for this episode' | translate }}
        @if (issuedReport.issuedAt) {
          &mdash; {{ formatDateTime(issuedReport.issuedAt) }}
        }
      </span>
    </div>
  }

  <div class="discharge-report-header-card">
    <div class="discharge-report-header-grid">
      @if (patientName) {
        <div class="discharge-report-header-row">
          <span class="discharge-report-header-label">{{ 'Patient' | translate }}</span>
          <span class="discharge-report-header-value">{{ patientName }}</span>
        </div>
      }

      @if (authorName) {
        <div class="discharge-report-header-row">
          <span class="discharge-report-header-label">{{ 'Author' | translate }}</span>
          <span class="discharge-report-header-value">{{ authorName }}</span>
        </div>
      }

      <div class="discharge-report-header-row">
        <span class="discharge-report-header-label">{{ 'Document Date' | translate }}</span>
        <span class="discharge-report-header-value">{{ formatDateTime(report.header.date) }}</span>
      </div>

      @if (documentStatusText) {
        <div class="discharge-report-header-row">
          <span class="discharge-report-header-label">{{ 'Status' | translate }}</span>
          <span class="discharge-report-header-value">{{ documentStatusText }}</span>
        </div>
      }

      @if (report.header.period?.start || report.header.period?.end) {
        <div class="discharge-report-header-row">
          <span class="discharge-report-header-label">{{ 'Episode Period' | translate }}</span>
          <span class="discharge-report-header-value">
            {{ formatDate(report.header.period?.start) }}
            @if (report.header.period?.end) {
              &ndash; {{ formatDate(report.header.period?.end) }}
            }
          </span>
        </div>
      }
    </div>
  </div>
</div>